export function distinctValues<T extends object>(list: T[], key: keyof T): Array<T[keyof T]> {
  return [...new Set(list.map(x => x[key]))];
}
